export const VIEW_EVENT = Object.freeze({
    PAGE_VIEW: 'page_view',
});

export const VIEW_NAME = Object.freeze({
    DASHBOARD: 'dashboard',
    LIVE_MAP: 'live_map',
    NOT_FOUND: 'not_found',
    REQUESTS: 'requests',
    ROUTES: 'routes',
    TEAM: 'team',
});
